import { render, staticRenderFns } from "./Progressbar.vue?vue&type=template&id=6c9c4ec6&"
import script from "./Progressbar.vue?vue&type=script&lang=ts&"
export * from "./Progressbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports